"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authTheme = exports.defaultTheme = exports.NORTHSTAR_COLORS = exports.useMediaQuery = exports.ThemeProvider = exports.makeStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
Object.defineProperty(exports, "makeStyles", { enumerable: true, get: function () { return styles_1.makeStyles; } });
Object.defineProperty(exports, "ThemeProvider", { enumerable: true, get: function () { return styles_1.ThemeProvider; } });
var useMediaQuery_1 = require("@material-ui/core/useMediaQuery");
Object.defineProperty(exports, "useMediaQuery", { enumerable: true, get: function () { return __importDefault(useMediaQuery_1).default; } });
var color_1 = require("../config/color");
Object.defineProperty(exports, "NORTHSTAR_COLORS", { enumerable: true, get: function () { return color_1.NORTHSTAR_COLORS; } });
var default_1 = require("./default");
Object.defineProperty(exports, "defaultTheme", { enumerable: true, get: function () { return default_1.theme; } });
Object.defineProperty(exports, "authTheme", { enumerable: true, get: function () { return default_1.authTheme; } });
//# sourceMappingURL=index.js.map